export const SumObjects = (array, key) => {
  if (!array || !array.length) {
    return 0;
  }
  return array.map((value) => value[key]).reduce((acc, amount) => acc + amount);
};
